<template>
  <div class="Banner">
    <div class="info">
      <i class="el-icon-warning"></i>
      <p>Configure banners for display on home page. Recommend image ratio 14:6</p>
    </div>
    <table class="table">
      <thead class="head">
      <tr>
        <th class="head_item" style="width: 40px">Sort</th>
        <th class="head_item" style="width: 120px">Banner Type</th>
        <th class="head_item" style="width: 200px">Target Name</th>
        <th class="head_item" style="width: 100px">Image</th>
        <th class="head_item"></th>
      </tr>
      </thead>
      <tbody class="body">
      <template v-if="banner_list.length!==0">
        <tr class="body_row" v-for="(banner,index) in banner_list" :key="banner.id">
          <td class="body_item" style="width: 40px">
            <div style="display: flex;flex-direction: column;align-items: center">
              <el-button class="arrow" :disabled="index===0" icon="el-icon-arrow-up"
                         @click="onOrderChange(index,'up')"></el-button>
              <p>{{banner.order}}</p>
              <el-button class="arrow" :disabled="index===banner_list.length-1" icon="el-icon-arrow-down"
                         @click="onOrderChange(index,'down')"></el-button>
            </div>
          </td>

          <td class="body_item" style="width: 120px">
            <p>{{banner.banner_type_text}}</p>
          </td>

          <td class="body_item" style="width: 200px">
            {{banner.banner_target_name}}
          </td>

          <td class="body_item" style="width: 100px">
            <el-image
                style="width: 280px; height: 120px"
                :src="banner.banner_url"
                fit="cover">
            </el-image>
          </td>

          <td class="body_item">
            <el-button class="action" type="primary" size="mini"
                       @click="onEdit(banner.id,banner.banner_type,banner.banner_target,banner.banner_url)">
              Edit
            </el-button>
            <el-button class="action" type="danger" size="mini" @click="onDelete(banner.id)">Delete
            </el-button>
          </td>
        </tr>
      </template>

      <template v-if="banner_list.length===0&&banner_list!==false">
        <tr class="body_row">
          <td class="body_item"></td>
          <td class="body_item no_option">No Banner</td>
        </tr>
      </template>
      </tbody>
    </table>


    <el-button @click="dialog_visible = true" class="add" type="primary" size="medium" round="" icon="el-icon-plus">
      Create Banner
    </el-button>
    <el-button v-if="banner_list.length>=2" @click="onSortSave" class="add" size="medium" round="">
      Save sorting order
    </el-button>

    <el-dialog width="30%" style="min-width: 1400px" title="Edit Banner" :visible.sync="dialog_visible">
      <el-form v-if="dialog_visible" :model="item_holder" :rules="rules" ref="bannerForm">
        <el-form-item label="Banner Type" label-width="120px" prop="banner_type">
          <el-select v-model="item_holder.banner_type" @change="onTypeChange" placeholder="Select Banner Type">
            <el-option
                v-for="type in type_list"
                :key="type.code"
                :label="type.name"
                :value="type.code">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Banner Target" label-width="120px" prop="banner_target">
          <el-select v-model="item_holder.banner_target" placeholder="Select Banner Target">
            <el-option
                v-for="item in option_list[item_holder.banner_type-1]"
                :key="item.target_id"
                :label="item.target_name"
                :value="item.target_id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Banner Image" label-width="120px" prop="banner_url">
          <ImageUpload style="max-width: 150px;overflow: hidden"
                       :limit="1" target="banner" :input="current_input"
                       @output="onUpdateImage"></ImageUpload>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"
                   @click="onBannerSave(item_holder.id,item_holder.banner_type,item_holder.banner_target,item_holder.banner_url)">
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ImageUpload from "@/components/Images/Images";
  import {adjustArrayOrder} from "@/utils/util";
  import {deleteBanner, getBannerList, getBannerOptions, orderBanner, saveBanner} from "@/utils/api";

  export default {
    components: {
      ImageUpload
    },
    props: {},
    data: () => {
      return {
        type_list: [
          {
            code: 1,
            name: 'Challenge'
          }, {
            code: 2,
            name: 'Product'
          }, {
            code: 3,
            name: 'Vendor'
          },{
            code: 4,
            name: 'Brand'
          },
        ],
        current_input: [],
        item_holder: {
          id: '',
          banner_type: '',
          banner_target: '',
          banner_url: ''
        },
        option_list: [],
        dialog_visible: false,
        banner_list: false,
        rules: {
          banner_type: [
            {required: true, message: 'Banner type is required', trigger: 'blur'},
          ],
          banner_target: [
            {required: true, message: 'Banner target is required', trigger: 'blur'},
          ],
          banner_url: [
            {required: true, message: 'Banner image is required', trigger: 'blur'},
          ],
        }
      }
    },
    watch: {
      dialog_visible: function (n) {
        if (!n) {
          this.item_holder = {
            id: '',
            banner_type: '',
            banner_target: '',
            banner_url: ''
          };
          getBannerList().then(res => {
            this.banner_list = res.banner_list
          })
        }
      }
    },
    methods: {
      onBannerSave(id, type, target, url) {
        this.$refs['bannerForm'].validate((valid) => {
          if (valid) {
            saveBanner(id, type, target, url).then(res => {
              if (res.errcode === 0) {
                this.$message.success(`Banner ${id === '' ? 'created' : 'saved'}`);
              } else {
                this.$message.error('Error');
              }
              this.dialog_visible = false
            })
          } else {
            this.$message.error('Check your inputs');
            return false;
          }
        });
      },
      onTypeChange() {
        this.item_holder['banner_target'] = ''
      },
      onUpdateImage(e) {
        if (e.image_list.length === 0) {
          this.item_holder.banner_url = ''
        } else {
          this.item_holder.banner_url = e.image_list[0]
        }
      },
      onSortSave() {
        this.$showLoading('Updating');
        orderBanner(this.banner_list).then(res => {
          this.$hideLoading();
          if (res.errcode === 0) {
            this.$message.success('Sorting order updated');
            getBannerList().then(res => {
              this.banner_list = res.banner_list
            })
          } else {
            this.$message.error('Error');
          }
        })
      },

      onOrderChange(index, type) {
        this.banner_list = adjustArrayOrder(index, this.banner_list, type)
      },

      onEdit(id, banner_type, banner_target, banner_url) {
        this.item_holder = {
          id: id,
          banner_type: banner_type,
          banner_target: banner_target,
          banner_url: banner_url
        };
        this.dialog_visible = true;
        setTimeout(() => {
          this.current_input = [banner_url];
        })
      },

      onDelete(id) {
        this.$confirm(`Are you sure to delete this banner? Products under it will reset their banner tag to default`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteBanner(id).then(res => {
            if (res.errcode === 0) {
              this.$message.success('Banner deleted');
              getBannerList().then(res => {
                this.banner_list = res.banner_list
              })
            } else {
              this.$message.error('Error');
            }
          })
        }).catch(() => {
        });
      },
    },
    beforeMount() {
      getBannerList().then(res => {
        this.banner_list = res.banner_list
      });
      getBannerOptions().then(res => {
        this.option_list = res.option_list
      })
    }
  };

</script>

<style lang="scss" scoped>
  @import "_Banner.scss";
</style>